import { Icon } from '@chakra-ui/react';

export default function AppLovinIcon(props) {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>AppLovin</title>
      <rect width="512" height="512" rx="96" fill="#1c1c1c" />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="700"
        fontSize="300"
        fill="#ffffff"
      >
        A
      </text>
    </Icon>
  );
}
